export enum OkDialogResult {
  Ok,
  Close
}
